var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPlayerAudio = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-DE63A36E-BBC3-49A8-B9CF-3677ED9EDA6E)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.976 15.753c.1.869-.114 1.75-.601 2.479-1.113 1.635-3.315 2.057-4.916.92a3.661 3.661 0 0 1-.901-5.022c1.113-1.635 3.315-2.056 4.917-.92V6.607L7.04 8.764v5.61a3.67 3.67 0 0 1-.638 2.07 3.48 3.48 0 0 1-4.904.88C-.09 16.188-.478 13.938.636 12.316c1.113-1.622 3.315-2.018 4.904-.881V3.961c0-.946.65-1.764 1.563-1.955L16.636.038C16.761.013 16.9 0 17.024 0c1.076 0 1.952.895 1.952 1.993zm-15.463.703c1.114 0 2.015-.933 2.027-2.07 0-1.15-.913-2.07-2.027-2.07-1.126 0-2.026.92-2.026 2.07s.913 2.07 2.026 2.07zM17.475 5.053V1.981c0-.026-.013-.064-.013-.09a.458.458 0 0 0-.538-.357l-9.52 1.97a.475.475 0 0 0-.363.461v3.263zm-2.002 13.204c.087 0 .162-.013.237-.025 1.115-.127 1.902-1.15 1.777-2.287h-.012v-.077c-.15-1.01-1-1.75-2.002-1.75-1.126 0-2.026.92-2.026 2.07s.913 2.07 2.026 2.07z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPlayerAudio);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico-player-audio.09cb1b81b820af7d64fe7efbb8a446f8.svg";